import { Delete, Edit } from "@mui/icons-material";

import { TableActions } from "../../components/v3";

/**
 * Route paths for the invoices module.
 * Single source of truth — reuse these instead of hard-coding `/client/invoices...` or `/invoices...` strings.
 */
export const INVOICES_ROUTES = {
  governmentAdd: "/client/invoices/add",
  governmentEdit: "/client/invoices/edit/:id",
  root: "/invoices",
  create: "/invoices/create",
  edit: "/invoices/:id/edit",
} as const;

export const getInvoiceTableColumns = (handleActions, hasEditInvoice, hasDeleteInvoice) => {
  const headers = [
    { field: "sl", headerName: "Sl", flex: 1 },
    { field: "invoiceNumber", headerName: "Invoice Number", flex: 2.5 },
    { field: "date", headerName: "Date", flex: 2 },
    { field: "amount", headerName: "Amount", flex: 2 },
  ];

  if (hasEditInvoice || hasDeleteInvoice) {
    headers.push({
      field: "actions",
      headerName: "Actions",
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        const actions = [];

        if (hasEditInvoice) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }

        if (hasDeleteInvoice) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }
        return <TableActions item={params} actions={actions} />;
      },
    });
  }

  return headers;
};

export const InvoiceItemColumns = ({ isTaxIncluded }) => {
  return [
    {
      field: "name",
      headerName: "Item Name",
      flex: 2,
      editable: true,
      valueSetter: (value, row) => ({ ...row, name: value }),
      renderCell: (params) => params.row.name || "-",
    },

    {
      field: "quantity",
      headerName: "Quantity",
      type: "number",
      align: "left",
      headerAlign: "left",
      flex: 1,
      editable: true,
      valueSetter: (value, row) => ({ ...row, quantity: value }),
      renderCell: (params) => {
        const qty = params.value;
        const unit = params.row.unitOfMeasure;
        if (!qty) return "-";
        return unit ? `${qty} ${unit}` : qty;
      },
    },

    {
      field: "unitPrice",
      headerName: "Price",
      type: "number",
      align: "left",
      headerAlign: "left",
      flex: 1,
      editable: true,
      valueSetter: (value, row) => ({ ...row, unitPrice: value }),
      renderCell: (params) => (params.value ? `₹ ${params.value}` : "-"),
    },
    {
      field: "taxPercentage",
      headerName: "Tax %",
      type: "number",
      align: "left",
      headerAlign: "left",
      flex: 1,
      editable: true,
      valueSetter: (value, row) => ({ ...row, taxPercentage: value }),
      renderCell: (params) => (params.value ? `${params.value}%` : "-"),
    },
    {
      field: "total",
      headerName: "Total",
      align: "left",
      headerAlign: "left",
      flex: 1,
      editable: false,
      type: "number",
      valueGetter: (value, row) => {
        const quantity = Number(row.quantity) || 0;
        const unitPrice = Number(row.unitPrice) || 0;
        const taxPercentage = Number(row.taxPercentage) || 0;
        const subtotal = quantity * unitPrice;

        if (!isTaxIncluded) {
          return subtotal;
        }

        return subtotal + subtotal * (taxPercentage / 100);
      },
      renderCell: (params) => {
        const total = params.value;
        return total ? `₹ ${total.toLocaleString("en-IN", { maximumFractionDigits: 2 })}` : "-";
      },
    },
  ];
};
